/* RESPONSIBLE TEAM: team-data-foundations */
import Model, { attr } from '@ember-data/model';

export default class DataExportJobDefinition extends Model {
  @attr('string') schedule;
  @attr('string') state;
  @attr('boolean') verified;
}
